<template>
    <li class="flex-x-middle popover-list">
        <i class="popover-list-icon "
            :class="data.file.type.includes('image') ? 'el-icon-picture-outline' : 'el-icon-document'"></i>
        <div class="flex-y flex-1 popover-list-title">
            <span>{{data.file.name}}</span>
            <span class="popover-list-size">{{getSize()}}</span>
        </div>
        <div>
            <span class="err-msg">{{tipMsg}}</span>
        </div>
        <i v-if="loading" class="el-icon-loading popover-list-btn"></i>
        <template v-else>
            <div v-if="result" :class="{ hasRouter: data.route }">
                <i v-if="data.route"
                    class="el-icon-folder-opened popover-list-btn folder-icon"
                    @click.stop="toRoute"></i>
                <i v-else class="el-icon-check popover-list-btn succ-icon"></i>
            </div>
            <i v-else class="el-icon-circle-close popover-list-btn"></i>
        </template>
    </li>
</template>
<script>
export default {
	props: {
		data: {
			type: Object,
			default () {
				return {}
			}
		}
	},
	data () {
		return {
			loading: true,
			interval: null,
			tipMsg: '',
			result: false
		}
	},
	methods: {
		getSize () {
			const { size } = this.data.file
			let num = size
			let unit = 'B'
			if (num >= 1024) {
				num = Math.round(num / 1024)
				unit = 'KB'
			}
			if (num >= 1024) {
				num = Math.round(num / 1024)
				unit = 'M'
			}
			return num + ' ' + unit
		},
		sendReq () {
			const { api, params = {}, succCondition, succCallback, failCallback, finishCallback } = this.data
			api(params).then(res => {
				console.log('succ', res)
				// 不同的api存在不同的成功条件
				// 如果存在【判断是否请求成功的函数】，则使用此函数
				if (succCondition && typeof (succCondition) == 'function') {
					if (!succCondition(res)) return
				} else {
					if (!res || res.code) return
				}
				this.tipMsg = res && typeof (res) == 'string' ? res : '上传成功'
				// 成功
				this.loading = false
				this.result = true
				if (this.interval) {
					clearInterval(this.interval)
					this.interval = null
				}
				this.$emit('uploadSucc')
				if (succCallback && typeof (succCallback) == 'function') succCallback(res)
				if (finishCallback && typeof (finishCallback) == 'function') finishCallback(res)
			}).catch(err => {
				console.log('err', err)
				this.loading = false
				this.result = false
				if (this.interval) {
					clearInterval(this.interval)
					this.interval = null
				}
				this.tipMsg = err || '上传失败'
				this.$emit('uploadFail')
				if (failCallback && typeof (failCallback) == 'function') failCallback(err)
				if (finishCallback && typeof (finishCallback) == 'function') finishCallback(err)
			})
		},
		toInterval () {
			this.sendReq()
			if (this.data.pollRequest) { // 轮询
				this.interval = setInterval(() => {
					this.sendReq()
				}, 2000)
			}
		},
		toRoute () {
			window.$router.push(this.data.route)
		}
	},
	created () {
		if (this.data.pollRequest) this.toInterval()
		else this.sendReq()
	},
	beforeDestroy () {
		if (this.interval) clearInterval(this.interval)
	}
}
</script>
<style lang="scss" scoped>
.popover-list {
    padding: 2px 15px;
    height: 50px;
    background: #f8f8f8;
    border-bottom: 1px solid #e5e5e5;
    color: #888;
    &:hover {
        background: darken(#f8f8f8, 5%);
        .hasRouter {
            .folder-icon {
                display: inherit;
            }
            .succ-icon {
                display: none;
            }
        }
    }
    &-icon {
        font-size: 20px;
        color: #1890ff;
    }
    &-title {
        font-size: 14px;
        padding: 0 10px;
    }
    &-size {
        font-size: 10px;
        margin-top: 4px;
        color: #bbb;
    }
    &-btn {
        padding: 4px;
        font-size: 18px;
        &.el-icon-check {
            color: #13ce66;
        }
        &.el-icon-circle-close {
            color: red;
            cursor: default;
        }
    }
    .folder-icon {
        display: none;
        cursor: pointer;
    }
    .err-msg {
        font-size: 12px;
    }
}
</style>
